module.exports = __webpack_public_path__ + "img/menu_black_24dp.9fdd87a7.svg";